import * as SessionManagementChannelDefinitions from '@tableau/microview-communication-service/lib/src/channelDefinitions/SessionManagementChannelDefinitions';

export function getSessionManagementServiceInstance(): SessionManagementService {
  return SessionManagementService.instance;
}

export class SessionManagementService {
  public static instance = new SessionManagementService();

  public sessionSiteUrlName(): string {
    const channel = new SessionManagementChannelDefinitions.SessionSiteUrlNameChannel();
    return channel.call().data?.seassionSiteUrlName || '';
  }

  public isExtractEncryptionEnabledOmniSwitch(): boolean {
    const channel = new SessionManagementChannelDefinitions.ExtractEncryptionEnabledOmniSwitchChannel();
    return channel.call().data?.extractEncryptionEnabled || false;
  }

  public catalogingOnSiteEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.CatalogOnsiteEnabledChannel();
    return channel.call().data?.catalogOnsiteEnabled || false;
  }

  public metricsOnSiteEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.MetricsOnSiteEnabledChannel();
    return channel.call().data?.metricsOnSiteEnabled || false;
  }

  public isNlpServiceEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.NlpServiceEnabledChannel();
    return channel.call().data?.isNlpServiceEnabled || false;
  }

  public askDataMode(): string {
    const channel = new SessionManagementChannelDefinitions.AskDataModeChannel();
    return channel.call().data?.askDataMode || '';
  }

  public sessionUserId(): string | undefined {
    const channel = new SessionManagementChannelDefinitions.SessionUserIDChannel();
    return channel.call().data?.sessionUserId;
  }

  public isSessionServerAdmin(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsSessionServerAdminChannel();
    return channel.call().data?.isSessionServerAdmin || false;
  }

  public isSessionSiteAdmin(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsSessionSiteAdminChannel();
    return channel.call().data?.isSessionSiteAdmin || false;
  }

  public isLimitedUserVisibilityChannel(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsLimitedUserVisibilityChannel();
    return channel.call().data?.isUserLimitedVisibility || false;
  }

  public isOnlineEnvironmentChannel(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsOnlineEnvironmentChannel();
    return channel.call().data?.isOnlineEnvironment || false;
  }

  public isCollectionsEnabledOnSite(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsCollectionsEnabledOnSiteChannel();
    return channel.call().data?.isCollectionsEnabledOnSite || false;
  }
}

const allowedModule = 'StatefulServicesTestHelper';
export function getSessionManagementServiceNewInstanceForTestOnly(callingModule: typeof allowedModule): SessionManagementService {
  if (callingModule !== allowedModule) {
    throw new Error(`This function is only allowed to be called from ${allowedModule}`);
  }
  return new SessionManagementService();
}

